export enum RedirectedFromCaRoutes {
  NewOrderForm = '/orders/new',
  EditOrderForm = '/orders/[orderId]',
}
